<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card flex">
      <i class="pi pi-chart-bar title-card-icon"></i>
      <div>
        <p class="mb-0 text-3xl title">{{'model.audits' | transloco}}</p>
        <p>{{'menu.descriptions.audits' | transloco}}</p>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <p-table
          [(first)]="first"
          [(rows)]="rows"
          [value]="audits"
          [totalRecords]="totalAudits"
          [responsive]="true"
          [paginator]="true"
          [rowsPerPageOptions]="[10,25,50]"
          [lazy]="true"
          (onLazyLoad)="onPageChange($event)"
          styleClass="p-datatable-striped"
          sortField="timestamp"
          dataKey="dataKey"
          [sortOrder]="-1"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="selection-column-width"></th>
              <th pSortableColumn="entityId">
                {{'attribute.entityId' | transloco}}
                <p-sortIcon field="entityId"></p-sortIcon>
              </th>
              <th pSortableColumn="entityType">
                {{'attribute.entityType' | transloco}}
                <p-sortIcon field="entityType"></p-sortIcon>
              </th>
              <th pSortableColumn="action">
                {{'attribute.action' | transloco}}
                <p-sortIcon field="action"></p-sortIcon>
              </th>
              <th *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                {{'model.tenant' | transloco}}
              </th>
              <th *ngIf="'ROLE_ADMIN' | userHasRole: false">
                {{'model.organization' | transloco}}
              </th>
              <th pSortableColumn="timestamp">
                {{'attribute.timestamp' | transloco}}
                <p-sortIcon field="timestamp"></p-sortIcon>
              </th>
              <th pSortableColumn="user.username">
                {{'attribute.username' | transloco}}
                <p-sortIcon field="user.username"></p-sortIcon>
              </th>
              <th pSortableColumn="application.code" *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                {{'attribute.application' | transloco}}
                <p-sortIcon field="application.code"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-audit let-expanded="expanded">
            <tr *ngIf="!loadingAudits" class="fadein">
              <td>
                <span class="p-column-title bold">{{'common.expand' | transloco}}</span>
                <button
                  [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                  [pRowToggler]="audit"
                  pButton
                  pRipple
                  class="p-button-text p-button-rounded p-button-plain"
                  type="button"
                ></button>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.entityUuid' | transloco}}</span>
                {{audit.entityId}}
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.entityType' | transloco}}</span>
                {{audit.entityType}}
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.action' | transloco}}</span>
                <p-tag
                  [value]="audit.action">
                </p-tag>
              </td>
              <td *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                <span class="p-column-title bold">{{'model.tenant' | transloco}}</span>
                <a *ngIf="audit.entityTenantUuid" [routerLink]="['/management/tenants', audit.entityTenantUuid, 'details']">
                  {{audit.entityTenantUuid | tenantsResolver}}
                </a>
              </td>
              <td *ngIf="'ROLE_ADMIN' | userHasRole: false">
                <span class="p-column-title bold">{{'model.organization' | transloco}}</span>
                <a *ngIf="audit.entityOrganizationUuid" [routerLink]="['/management/organizations', audit.entityOrganizationUuid, 'details']">
                  {{audit.entityOrganizationUuid | organizationsResolver}}
                </a>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.timestamp' | transloco}}</span>
                <p class="text-right md:text-left">{{audit.timestamp | customDate}}</p>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.username' | transloco}}</span>
                <p class="text-right md:text-left">{{audit.username}}</p>
              </td>
              <td *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                <span class="p-column-title bold">{{'attribute.application' | transloco}}</span>
                <p class="text-right md:text-left">{{audit.appCode}}</p>
              </td>
            </tr>
            <tr *ngIf="loadingAudits" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height selection-column-width" *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height w-12rem" *ngIf="'ROLE_ADMIN' | userHasRole: false">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height selection-column-width" *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                <p-skeleton height="1em"></p-skeleton>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="rowexpansion" let-audit>
            <tr>
              <td colspan="9">
                <div class="grid">
                  <div class="col-6">
                    <b>{{'attribute.oldValue' | transloco}}:</b>
                  </div>
                  <div class="col-6 left-border">
                    <b>{{'attribute.newValue' | transloco}}:</b>
                  </div>
                  <div class="col-6">
                    <ngx-json-viewer *ngIf="audit.oldValue" [json]="audit.oldValue"></ngx-json-viewer>
                    <div *ngIf="!audit.oldValue"><i>{{'empty.oldValue' | transloco}}</i></div>
                  </div>
                  <div class="col-6 left-border">
                    <ngx-json-viewer *ngIf="audit.newValue" [json]="audit.newValue"></ngx-json-viewer>
                    <div *ngIf="!audit.newValue"><i>{{'empty.newValue' | transloco}}</i></div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between" *ngIf="totalAudits == 0">
              {{'pagination.empty' | transloco}}
            </div>
            <div class="flex align-items-center justify-content-between" *ngIf="totalAudits > 0">
              {{'pagination.showing' | transloco}} {{first+1}}
              {{'pagination.to' | transloco}} {{(first+rows) >= totalAudits ? totalAudits : (first+rows)}}
              {{'pagination.of' | transloco}} {{totalAudits}}
              {{(totalAudits > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
